import { Flex, Radio, Stack } from "@chakra-ui/react"
import { Form, Formik } from "formik"
import { useDispatch, useSelector } from "react-redux"
import { ButtonBack, InputField, Layout, SelectField } from "../../../components"
import { RootState } from "../../app/mainReducer"
import { AcaoHeader, BotaoFinalizarEntrega, Images, ModalObservacoes, Temporizador } from "../components"
import { erroDoMotivoDevolucao, getMotivosNaoEntrega } from "../utils"
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom"
import { entregaActions } from "../reducer"
import RadioField from "../../../components/RadioField"
import { Carga, CargaItem } from "../../carga/types"
import { buscaCoordenadasParaEntrega } from "../../../utils/geolocalizacao"
import config from "../../../utils/config"

const RegistrarDevolucao = () => {
  const gestao_entrega_temporario = useSelector((state: RootState) => state.entrega.gestao_entrega_temporario);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ukey, tipo, j10_ukey } = useParams();
  const e_transbordo = tipo === 'transbordo';

  const carga = useSelector((state: RootState) =>
    (state.carga.carga || state.carga.cargas?.find((i) => i.j14_ukey === ukey))
  );

  const nota = useSelector((state: RootState) => carga?.itens?.find((i: CargaItem) => i.j10_ukey === j10_ukey));

  const [rotaDirecionar, setRotaDirecionar] = useState<string | null>(null);

  useEffect(() => {
    if (nota?.nota_dados_complementares_entrega_link_app) {
      const parsedUrl = new URL(nota?.nota_dados_complementares_entrega_link_app);
      setRotaDirecionar(parsedUrl.pathname);
    } else {
      setRotaDirecionar(null);
    }
  }, [])

  useEffect(() => {
    if (!gestao_entrega_temporario) {
      if (e_transbordo) {
        navigate(`/`)
        return;
      }

      if (rotaDirecionar) {
        navigate(rotaDirecionar);
        return;
      }

      if (config.agrupaCargasPeloAgrupamento && carga?.n01_ukey) {
        navigate(`/agrupamentos/${carga?.n01_ukey}`);
        return;  
      }

      navigate(`/cargas/${ukey}`)
    }
  }, [navigate, gestao_entrega_temporario]);

  const [openModalObservacoes, setOpenModalObservacoes] = useState(false);
  const [openedModalObservacoes, setOpenedModalObservacoes] = useState(false);

  return (
    <Layout showFooter={true} isLoading={false} title={
      <>
        <ButtonBack />
        <Temporizador />
      </>
    }>
      <AcaoHeader label="Registrar Devolução" />

      <Flex px={4} width="full" direction="column">
        {gestao_entrega_temporario && <Formik
          enableReinitialize
          initialValues={gestao_entrega_temporario}
          onSubmit={async (val, { setErrors }) => {
            const erroMotivo = erroDoMotivoDevolucao(val, config.motivoDevolucaoTextoLivre);
            if (erroMotivo) {
              setErrors(config.motivoDevolucaoTextoLivre
                ? { motivo_devolucao_descricao: erroMotivo }
                : { motivo_devolucao: erroMotivo })
              return;
            }
            if (config.devolucaoExigirApenasFoto2) {
              if (!val.url_imagem2) {
                setErrors({ url_imagem2: "Tire a foto 2!" })
                return;
              }
            } else {
              if (!val.url_imagem1) {
                setErrors({ url_imagem1: "Tire a foto do canhoto!" })
                return;
              }
            }

            if (!openedModalObservacoes) {
              setOpenModalObservacoes(true);
              return;
            }

            const coordenadas = await buscaCoordenadasParaEntrega(val);

            if (!coordenadas) {
              dispatch(entregaActions.setError("Não foi possível obter a geolocalização. Verifique se o GPS está ativo, conceda permissão ao navegador e tente novamente ao ar livre."));
              return;
            }

            dispatch(entregaActions.registraNovoGestaoEntrega({
              gestao: {
                ...val,
                latitude: coordenadas.latitude,
                longitude: coordenadas.longitude,
              },
              carga: carga as Carga
            }))
          }}
        >
          {({ values, handleSubmit, isSubmitting }) => (
            <Form>
              <InputField
                label="Nome do Recebedor"
                placeholder="Nome do Recebedor"
                name="nome_recebedor"
              />
              {/* <InputField
                label="Documento do Recebedor (RG ou CPF)"
                placeholder="Documento do Recebedor (RG ou CPF)"
                name="rg_recebedor"
                type="tel"
              /> */}
              {config.motivoDevolucaoTextoLivre ? (
                <InputField
                  textarea
                  rows={3}
                  maxLength={200}
                  label="Motivo da Devolução"
                  placeholder="Descreva o motivo da devolução"
                  name="motivo_devolucao_descricao"
                />
              ) : (
                <SelectField
                  label="Motivo da Devolução"
                  name="motivo_devolucao"
                >
                  {getMotivosNaoEntrega().map(motivo => (
                    <option key={`${motivo.value}`} value={motivo.value}>{motivo.name}</option>
                  ))}
                </SelectField>
              )}

              {(config.motivoDevolucaoTextoLivre || values.motivo_devolucao == '4') && <RadioField mt={2} name="e_tentativa_entrega">
                <Stack mx="auto" direction="column" bg="white" p={4} borderRadius={5}>
                  <Radio size="lg" value={0}>Não vou reentregar, finalizar.</Radio>
                  <Radio size="lg" value={1}>Vou reentregar depois.</Radio>
                </Stack>
              </RadioField>}

              <Images large={true} recusaEntrega={config.devolucaoExigirApenasFoto2} />

              <ModalObservacoes onSubmited={handleSubmit} onOpenModal={openModalObservacoes} onOpenedModal={() => setOpenedModalObservacoes(true)} isLoading={isSubmitting} />

              <BotaoFinalizarEntrega isLoading={isSubmitting} />
            </Form>
          )}
        </Formik>}
      </Flex>

    </Layout>
  )
}

export default RegistrarDevolucao;